export default "__VITE_ASSET__B2J36WlA__"